module.exports = __webpack_public_path__ + "static/media/flexi_point.32074fa3.svg";